import { PointerLockControls } from '@react-three/drei'
import { useEffect, useRef } from 'react'

export default function LockedPointerControls() {
  const controlsRef = useRef(null)

  useEffect(() => {
    const onPointerLockChange = () => {
      if (document.pointerLockElement === null) {
        // Pointer lock lost, reacquire it
        controlsRef.current.lock()
      }
    }

    document.addEventListener('pointerlockchange', onPointerLockChange)

    return () => {
      document.removeEventListener('pointerlockchange', onPointerLockChange)
    }
  }, [])

  return <PointerLockControls ref={controlsRef} />
}